import { Action } from '@ngrx/store';
import { Product } from '@vestiaire/api-sdk-angular';

export enum ProductActionTypes {
  AddToWishlist = '[Product] Add to wishlist',
  AddToWishlistSuccess = '[Product] Added to wishlist',
  RemoveToWishlistSuccess = '[Product] Removed to wishlist',
  Like = '[Product] Like product',
  LikeSuccess = '[Product] product Liked',
  Comment = '[Product] Comment',
  Share = '[Product] Share',
  CreateAlertSuccess = '[Product] Alert created',
  CreateHolidaysEndAlertSuccess = "[Product] Seller's Holidays end Alert created",
  DeleteHolidaysEndAlertSuccess = "[Product] Seller's Holidays end Alert Deleted",
  CreatePriceAlertSuccess = '[Product] Price alert created',
  MakeOfferSuccess = '[Product] Offer saved',
  UnloadProduct = '[Product] Unload product',
  LoadProductSuccess = '[Product] Product loaded',
  ClickConsigmentCTA = '[Product] Send "ClickConsigmentCTA" '
}

abstract class ProductAction {
  constructor(public payload: Product) {}
}

export class AddToWishlist extends ProductAction implements Action {
  readonly type = ProductActionTypes.AddToWishlist;
}

export class AddToWishlistSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.AddToWishlistSuccess;
}

export class RemoveToWishlistSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.RemoveToWishlistSuccess;
}

export class Like extends ProductAction implements Action {
  readonly type = ProductActionTypes.Like;
}

export class LikeSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.LikeSuccess;
}

export class Comment extends ProductAction implements Action {
  readonly type = ProductActionTypes.Comment;
}

export class Share implements Action {
  readonly type = ProductActionTypes.Share;

  constructor(public payload: { network: string; productId: string }) {}
}

export class CreateAlertSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.CreateAlertSuccess;
}

export class CreateHolidaysEndAlertSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.CreateHolidaysEndAlertSuccess;
}

export class DeleteHolidaysEndAlertSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.DeleteHolidaysEndAlertSuccess;
}

export class ClickConsigmentCTA implements Action {
  constructor(public position: string) {}
  readonly type = ProductActionTypes.ClickConsigmentCTA;
}

export class CreatePriceAlertSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.CreatePriceAlertSuccess;
}

export class MakeOfferSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.MakeOfferSuccess;
}

export class LoadProductSuccess extends ProductAction implements Action {
  readonly type = ProductActionTypes.LoadProductSuccess;
}

export class UnloadProduct extends ProductAction implements Action {
  readonly type = ProductActionTypes.UnloadProduct;
}

export type ProductActions =
  | AddToWishlist
  | AddToWishlistSuccess
  | RemoveToWishlistSuccess
  | Like
  | LikeSuccess
  | Comment
  | Share
  | CreateAlertSuccess
  | CreateHolidaysEndAlertSuccess
  | DeleteHolidaysEndAlertSuccess
  | CreatePriceAlertSuccess
  | MakeOfferSuccess
  | LoadProductSuccess
  | UnloadProduct
  | ClickConsigmentCTA;
